
import functions from "../functions";
import accBookingModal from "./accBookingModal";


class Cart  {
    // cartData: [],
    // uxCartData: [],
    // $bookingBtns: null,
    // $cartLengthBtns: null,
    // $cart: null,
    // $cartBody: null,
    // $cartItemCopy: null,
    // $itemAddedMsg: null,
    // $continueToPayment: null,
    // cartTotal: 0,
    // $total: null,
    constructor() 
    {
        this.getCartData();

        this.$bookingBtns = $('.cart-book');
        this.$cartLengthBtns = $('.cart-length');
        this.$cart = $('.cart');

        if (! this.$cart.length) return;

        accBookingModal.init();

        this.$cartBody = this.$cart.find('.card-body');
        this.$cartItemCopy = this.$cartBody.find('.cart-item-copy').first();
        this.$total = this.$cart.find('.total');
        this.$itemAddedMsg = $('.cart-message');
        this.$continueToPayment = this.$cart.find('.cart-payment');
        this.cartTotal = 0;

        this.setCartLenght();
        this.renderCart();
        this.registerRemoveFromCartEvent();

        // this.setBookBtnUrl();

        this.$cart.find('.close-cart').on('click', e => {
            let $elem = $(e.currentTarget);
            let $dropdown = $elem.parents('.dropdown');
            $dropdown.find('.cart-btn').first().click();

        })

        this.$itemAddedMsg.on('click', e => {
            if (! $(e.target).hasClass('cart-book')) this.$itemAddedMsg.removeClass('show');
        })
       
        $(document).on('click', '.add-to-cart', e => {
            let $elem = $(e.currentTarget);

            this.getCartData();
            let params = $elem.attr('href').split('?')[1] || '';

            params = params.split('&');

            let unitData = {};

            params.forEach((val, idx) => {
                let [key, value] = val.split('=');

                unitData[key] = value;
            })

            
            let id = Math.floor(Math.random() * 1000000);
            let title = $elem.attr('data-title') || '';
            let image = $elem.attr('data-image') || null;

            unitData['image'] = image;
            unitData['title'] = title;
            unitData['cartId'] = id;

            if ( ! accBookingModal.$modal.length)
            {
                this.updateTotal(+(unitData['price'] || 0));
                this.addUnitToCart(unitData);
                this.setCartLenght();
                this.showItemAddedMsg(unitData);
                // this.registerRemoveFromCartEvent();

                const $unit = $('.booking-unit-card[data-unitid=' + unitData['unitId'] + ']');
                $unit.find('.added-to-cart').removeClass('d-none');
                $unit.find('.label-from').removeClass('d-none');
                $unit.find('.label-total').addClass('d-none');
                $unit.find('.add-to-cart').addClass('d-none');
    
                $unit.find('.no-calculation').addClass('d-none');
                $unit.find('.calculation').addClass('d-none');
                $unit.find('.price-wrap').addClass('d-none');
            }

            accBookingModal.handle(unitData);

           

        });

        this.$continueToPayment.on('click', e => {
            let $elem = $(e.currentTarget);

            if (! this.cartData.length)
            {
                let $dropdown = $elem.parents('.dropdown');
                $dropdown.find('.cart-btn').first().click();
            }
            else
            {
                var url = $elem.attr('data-href');
                window.location = url;
            }
        })



    }
    getCartData()
    {
        let cartData = functions.getCookie('cart_data') || '';
        this.cartData = cartData ? JSON.parse(cartData) : [];

        let uxCartData = functions.getCookie('ux_cart_data') || '';
        this.uxCartData = uxCartData ? JSON.parse(uxCartData) : [];
    }
    setCartData()
    {
        functions.setCookie('ux_cart_data', JSON.stringify(this.uxCartData), .3);
        functions.setCookie('cart_data', JSON.stringify(this.cartData), .3);
    }
    addUnitToCart(unitData)
    {
        this.uxCartData.push(unitData);
        this.renderCartItem(unitData);

        let data = $.extend({}, unitData);

        delete data['price'];
        delete data['title'];

        this.cartData.push(data);

        this.setCartData();
    }
    renderCartItem(unitData)
    {

        let $item = this.$cartItemCopy.clone();

        $item.removeClass('cart-item-copy d-none');

        let [adults, childen] = unitData['guests'].split(',')

        $item.find('.cart-item-title').text(unitData['title']);
        $item.find('.period').text(functions.formatDate(unitData['dateFrom']) + ' - ' + functions.formatDate(unitData['dateTo']));
        $item.find('.guests-number').text((+adults + +(childen || 0)));
        $item.find('.item-price').text( '€ ' + (unitData['price'] || 0));
        $item.find('.remove-from-cart').attr('data-cartid', unitData['cartId']);

        if (unitData['parentId'] || null) $item.addClass('child');

        this.$cart.find('.cart-items').append($item.clone());
    }
    renderCart()
    {
        if (this.uxCartData.length)
        {
            this.uxCartData.forEach((unitData, index) => {
                this.renderCartItem(unitData);
                this.updateTotal(unitData['price'] || 0);
            })
        }
    }
    setCartLenght()
    {
        if (this.uxCartData.length && this.$cartLengthBtns.length) 
            {
                this.$cartLengthBtns.each((index, elem) => {
                    let $elem = $(elem);
                    let hideColon = $elem.prev().css('display') == 'none';
                $elem.text((hideColon ? '' : ': ') + (this.uxCartData.length));
            })

        }
        else this.$cartLengthBtns.text('')
    }
    registerRemoveFromCartEvent()
    {
        $('.cart').on('click', '.remove-from-cart', e => {
            let $elem = $(e.currentTarget);
            this.getCartData();
            let idToRemove = $elem.attr('data-cartid');

            let itemToRemove = this.uxCartData.filter(item => item.cartId == idToRemove)[0] || [];

            this.cartData = this.cartData.filter(item => item.cartId != idToRemove);
            this.uxCartData = this.uxCartData.filter(item => item.cartId != idToRemove);
            
            this.updateTotal(-itemToRemove['price']);
            this.removeFromCart(idToRemove);
            this.setCartLenght();
            this.setCartData();

            $(document).trigger('removed-from-cart', [idToRemove]);
            
            e.stopPropagation();
        })
    }
    updateTotal(price) 
    {
        this.cartTotal += +price;
        this.$total.text( '€ ' + (Math.round(+this.cartTotal * 100) / 100).toFixed(2));
    }
    setBookBtnUrl()
    {
       
        this.$bookingBtns.attr('href', 
            this.$bookingBtns.attr('href').split('?')[0] + '?cart_data=' + JSON.stringify(urlData)
        )
    }
    removeFromCart(id)
    {
        this.$cart.find(`[data-cartid=${id}]`).parents('.cart-item').remove();
    }
    showItemAddedMsg(data)
    {
        this.$itemAddedMsg.addClass('show');
        this.$itemAddedMsg.find('.title').html(data['title'] || '');
        this.$itemAddedMsg.find('.price-price').html( '€ ' + (data['price'] || 0));

        setTimeout(() => {
            this.$itemAddedMsg.removeClass('show');
            this.$itemAddedMsg.find('.title').html('');
            this.$itemAddedMsg.find('.price-price').html('');
        }, 15000);
    }
    isUnitWithPeriodInCart(params, unitId) {
        return this.cartData && this.cartData.some(function (item) {
            if (item.unitId != unitId) return false;

            if (item['dateFrom'] <= params.dateFrom && params.dateFrom <= item['dateTo']) return true; // b starts in a
            if (item['dateFrom'] <= params.dateTo   && params.dateTo   <= item['dateTo']) return true; // b ends in a
            if (params.dateFrom <  item['dateFrom'] && item['dateTo']   <  params.dateTo) return true; // a in b

            return false;
        });
    }


}

export default Cart;